import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getInfoUpdate,
  getIdInfoUpdate,
  createInfoUpdate,
  updateInfoUpdate,
  deleteInfoUpdate,
  updateInfoUpdateSetStatus,
  updateInfoUpdateConfirm,
  updateInfoUpdateCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteInfoUpdateVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  getTransportations,
  createTransportations,
  updateTransportations,
  deleteTransportations,
  updateInfoUpdateStartWorkFlow,
  uploadInfoUpdate,
  updateInfoUpdateAmend,
  uploadPicking,
  uploadBTS,
  uploadInfoUpdateWorkflow,
  updateInfoUpdateAmmend,
  getGenerateExcelBlob
} from "./infoUpdateAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permissionsInfo: [],
  permissionsList: [],
};

export const fetchInfoUpdate = createAsyncThunk(
  "InfoUpdate/fetchInfoUpdate",
  async (payload) => {
    const response = await getInfoUpdate(payload);
    return response;
  }
);

export const addInfoUpdate = createAsyncThunk(
  "InfoUpdate/addInfoUpdate",
  async (payload) => {
    const response = await createInfoUpdate(payload);
    return response;
  }
);

export const editInfoUpdate = createAsyncThunk(
  "InfoUpdate/editInfoUpdate",
  async (payload) => {
    const response = await updateInfoUpdate(payload);
    return response;
  }
);

export const editInfoUpdateConfirm = createAsyncThunk(
  "InfoUpdate/editInfoUpdateConfirm",
  async (payload) => {
    const response = await updateInfoUpdateConfirm(payload);
    return response;
  }
);
export const editInfoUpdateAmmend = createAsyncThunk(
  "InfoUpdate/editInfoUpdateAmmend",
  async (payload) => {
    const response = await updateInfoUpdateAmmend(payload);
    return response;
  }
);

export const editInfoUpdateCancel = createAsyncThunk(
  "InfoUpdate/editInfoUpdateCancel",
  async (payload) => {
    const response = await updateInfoUpdateCancel(payload);
    return response;
  }
);

export const editInfoUpdateStarWorkflow = createAsyncThunk(
  "InfoUpdate/editInfoUpdateStarWorkflow",
  async (payload) => {
    const response = await updateInfoUpdateStartWorkFlow(payload);
    return response;
  }
);

export const fetchIdInfoUpdate = createAsyncThunk(
  "InfoUpdate/fetchIdInfoUpdate",
  async (id) => {
    const response = await getIdInfoUpdate(id);
    return response;
  }
);

export const removeInfoUpdate = createAsyncThunk(
  "InfoUpdate/removeInfoUpdate",
  async (payload) => {
    const response = await deleteInfoUpdate(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "InfoUpdate/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadInfoUpdate(id, file);
    return response;
  }
);

export const AddUploadFileWorkflow = createAsyncThunk(
  "InfoUpdate/AddUploadFileWorkflow",
  async ({ id, file }) => {
    const response = await uploadInfoUpdateWorkflow(id, file);
    return response;
  }
);
export const AddUploadFileBTS = createAsyncThunk(
  "InfoUpdate/AddUploadFileBTS",
  async ({ id, file }) => {
    const response = await uploadBTS(id, file);
    return response;
  }
);

// vihicle
export const fetchInfoUpdateVehicle = createAsyncThunk(
  "InfoUpdate/fetchInfoUpdateVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addInfoUpdateVehicle = createAsyncThunk(
  "InfoUpdate/addInfoUpdateVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);
export const removeInfoUpdateVehicle = createAsyncThunk(
  "InfoUpdate/removeInfoUpdateVehicle",
  async (payload) => {
    const response = await deleteInfoUpdateVehicles(payload);
    return response;
  }
);

export const editInfoUpdateVehicle = createAsyncThunk(
  "InfoUpdate/editInfoUpdateVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

// party
export const fetchInfoUpdateParty = createAsyncThunk(
  "InfoUpdate/fetchInfoUpdateParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchInfoUpdatePartyAll = createAsyncThunk(
  "InfoUpdate/fetchInfoUpdatePartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addInfoUpdateParty = createAsyncThunk(
  "InfoUpdate/addInfoUpdateParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editInfoUpdateParty = createAsyncThunk(
  "InfoUpdate/editInfoUpdateParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeInfoUpdateParty = createAsyncThunk(
  "InfoUpdate/removeInfoUpdateParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

// Generate Excel
export const fetchGenerateExcel = createAsyncThunk(
  "InfoUpdate/fetchGenerateExcel",
  async (payload) => {
    const response = await getGenerateExcelBlob(payload);
    return response;
  }
);

export const infoUpdateSlice = createSlice({
  name: "infoUpdate",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
      setPermisionInfo: (state, action) => {
      state.permissionsInfo = action.payload;
    },
    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(addInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInfoUpdateConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdateConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInfoUpdateAmmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdateAmmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInfoUpdateCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdateCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInfoUpdateStarWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdateStarWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileBTS.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileBTS.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeInfoUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeInfoUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchInfoUpdateVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInfoUpdateVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addInfoUpdateVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addInfoUpdateVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editInfoUpdateVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editInfoUpdateVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeInfoUpdateVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeInfoUpdateVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected,setPermisionInfo,setPermisionList } = infoUpdateSlice.actions;

export const selectInfoUpdate = (state) => state.infoUpdate.data;
export const selectInfoUpdateVehicle = (state) => state.infoUpdate.data;
export const selectIdInfoUpdate = (state) => state.infoUpdate.dataId;
export const selectLoading = (state) => state.infoUpdate.loading;
export const selectError = (state) => state.infoUpdate.error;
export const selectPageNo = (state) => state.infoUpdate.pageNo;
export const selectPageSize = (state) => state.infoUpdate.pageSize;
export const selectTotalRecord = (state) => state.infoUpdate.totalRecord;
export const selectSelected = (state) => state.infoUpdate.selected;
export const selectResult = (state) => state.infoUpdate.result;
export const selectPermissionInfo = (state) => state.infoUpdate.permissionsInfo;
export const selectPermissionList = (state) => state.infoUpdate.permissionsList;

export default infoUpdateSlice.reducer;
